import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import LeadForm from "../lead-form";
import LoanCalculatorV2 from "../loan-calculator-v2";
import QuoteCalculator from "../quote-calculator";
import RoiCalculator from "../roi-calculator/pages/calc";

const router = createBrowserRouter([
  {
    path: "/",
    Component: LeadForm,
  },
  {
    path: "/quote",
    Component: LeadForm,
  },
  {
    path: "/quote1",
    Component: LeadForm,
  },
  {
    path: "/loan-calculator-v2",
    Component: LoanCalculatorV2,
  },
  {
    path: "/quote-calculator",
    Component: QuoteCalculator,
  },
  {
    path: "/roi-calculator",
    Component: RoiCalculator,
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
